import {Box} from "@mui/material";

const StampBox = ({ postcardWidth, show }: { postcardWidth: number, show: boolean }) => {
    return <Box sx={{ height: '45.50%', p: postcardWidth * 0.0141 / 8, pr: postcardWidth * 0.0282 / 8, display: 'flex', flexDirection: 'row', justifyContent: 'end' }}>
        {show && <img height={'100%'} style={{aspectRatio: 1}} alt={'Stamp'} src={'images/postcard/stamp.png'}/>}
    </Box>
}

export default StampBox